/**
 * Homepage / sticky-bar helpers for adding plain Gold or Purple Sea Moss.
 * Uses existing cart signatures only — does not change pricing or checkout.
 */
import { buildBlendSignature, CART_CURRENCY, mlToSizeId } from "./cartItem";

/**
 * @param {{ base?: 'gold' | 'purple', sizeMl: 300 | 500 | 1000, packaging?: 'jar' | 'pouch' }} opts
 */
export function makePlainSeaMossLine({ base = "gold", sizeMl, packaging = "jar" }) {
  const baseType = base === "purple" ? "purple" : "gold";
  const pack = packaging === "pouch" ? "pouch" : "jar";
  const sizeId = mlToSizeId(sizeMl);
  const sizeLabel = sizeId === "1L" ? "1 Litre" : sizeId;
  const blend_signature = buildBlendSignature(baseType, sizeId, [], "plain", pack);
  const label = baseType === "purple" ? "Purple" : "Gold";
  return {
    signature: blend_signature,
    blend_signature,
    name: `${label} Sea Moss Gel ${sizeLabel}`,
    description:
      pack === "pouch"
        ? `Plain ${label} Sea Moss Gel in a foil pouch. Keep refrigerated.`
        : `Plain ${label} Sea Moss Gel. Sea moss base and spring water. Keep refrigerated.`,
    base_type: baseType,
    packaging_type: pack,
    size_ml: sizeMl,
    herbs: [],
    qty: 1,
    product_type: "plain",
    currency: CART_CURRENCY,
  };
}

/** @param {{ sizeMl: 300 | 500 | 1000, packaging?: 'jar' | 'pouch' }} opts */
export function makePlainGoldLine(opts) {
  return makePlainSeaMossLine({ ...opts, base: "gold" });
}

export const HOME_SELECT_BASE_EVENT = "mossmatrix:select-base";

/** Scroll to the homepage order selector and optionally preselect Gold or Purple. */
export function scrollToSeaMossChoice(base) {
  if (typeof window === "undefined") return;
  if (base === "gold" || base === "purple") {
    window.dispatchEvent(new CustomEvent(HOME_SELECT_BASE_EVENT, { detail: { base } }));
  }
  const el =
    document.getElementById("choose-sea-moss") ||
    document.getElementById("order") ||
    document.getElementById("shop-favourites");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

/** Scroll to marketplace feedback on the homepage. */
export function scrollToMarketplaceFeedback() {
  if (typeof window === "undefined") return;
  const el = document.getElementById("marketplace-feedback");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}
